import { render, staticRenderFns } from "./conformacion-comite-convivencia.vue?vue&type=template&id=fecd1b92&"
import script from "./conformacion-comite-convivencia.vue?vue&type=script&lang=js&"
export * from "./conformacion-comite-convivencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports